import {LOGIN_ENDPOINT} from "../api-services/ApiEndpoints";

export const login = async (email, pin) => {
    const url = `${process.env.REACT_APP_API_URL}${LOGIN_ENDPOINT}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({email: email, password: pin})
        });

        const data = await response.json();

        if (!response.ok) {
            // Handle different error response structures
            let errorMessage = `Login failed with status ${response.status}`;
            
            if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                // Handle errors array structure
                errorMessage = data.errors[0].message || data.errors.map(err => err.message).join(', ');
            } else if (data?.message) {
                // Handle direct message
                errorMessage = data.message;
            } else if (data?.error?.message) {
                // Handle nested error message
                errorMessage = data.error.message;
            }
            
            throw new Error(errorMessage);
        }

        return data;
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};